var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-box',_vm._b({attrs:{"label":_vm.label,"model_type":_vm.modelType,"value":_vm.value},on:{"input":function (val) { return _vm.$emit('input', val.value ? val.value.id : null); }}},'search-box',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }